module.exports = __webpack_public_path__ + "static/media/bell.d11aea2c.svg";